import { MbscResource } from '@mobiscroll/react';
import { createContext } from 'react';

interface IResourceOrderValue {
  draggedResource: MbscResource | null;
  setDraggedResource: (value: MbscResource | null) => void;
}

export const ResourceOrderContext = createContext<IResourceOrderValue | null>(
  null
);
